import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import Select from '../select';
import { updateCustomer, updateSubscription, setSubscriptionExpiry, getSubscriptionDetail, setShouldUpdateList } from "../../slices/subscriptions";
import { formatMoney, formatMoneyWithCurrency } from "../../utils";
import { SvgPercentage } from "../svg";
import FormDatepicker from "../datepicker";

const tranlations =  [
    gettext('Discount in %'),
    gettext('Discount categories'),
    gettext("Plan"),
    gettext("Please select plan"),
    gettext("Plan Variant"),
    gettext("Please select variant"),
    gettext("Valid until"),
    gettext('Reference'),
    gettext('Field cannot be blank'),
    gettext("No discount"),
    gettext("Discount %"),
    gettext("Specify amount"),
    gettext('Field cannot be blank'),
    gettext('Please enter a number'),
    gettext('Field cannot be blank'),
    gettext('Please enter a number'),
    gettext("Amount to charge"),
    gettext('Description'),
    gettext("Save"),
]

const SubscriptionForm = ({ subscription, callback, editing = false }) => {
    const dispatch = useDispatch()
    const plans = useSelector((state) => state.plans.results)
    // const [selectedPlan, setSelectedPlan] = useState(plans.find(plan => plan.id === parseInt(subscription.plan.parent_id)))
    const [selectedPlan, setSelectedPlan] = useState()
    const [selectedVariant, setSelectedVariant] = useState()
    // const [selectedVariant, setSelectedVariant] = useState(selectedPlan.variants.find(variant => variant.id === parseInt(subscription.plan.id)))
    const [calculatedTotal, setCalculatedTotal] = useState(0)
    const [calculatedTotalFormatted, setCalculatedTotalFormatted] = useState("")
    const [isEditing, setIsEditing] = useState(false)
    const [discountType, setDiscountType] = useState('disabled')

    const selectRef = useRef();

    const {
        register,
        handleSubmit,
        reset,
        resetField,
        watch,
        setValue,
        getValues,
        setFocus,
        formState: {
            errors,
            isDirty,
        }
    } = useForm({
        defaultValues: {
            expires: subscription ? subscription.active_until : new Date(),
            // reference: subscription?.reference,
        }
    });
    const watchFields = watch(['discount', 'amount'])


    // ----- Unused -> add for selectable discount type
    // const [selectedDiscount, setSelectedDiscount] = useState(subscription.dicount?.id || {})
    // const [selectedDiscountOption, setSelectedDiscountOption] = useState('input')
    // const discounts = useSelector((state) => state.discounts.results)
    // const discountOptions = [
    //     { value: 'input', text: gettext('Discount in %') },
    //     { value: 'dropdown', text: gettext('Discount categories') }
    // ];
    // -----

    useEffect(() => {
        if (isDirty) {
            setIsEditing(true)
        }
    }, [isDirty])


    let timer = null;

    const onSubmit = (data) => {
        Promise.resolve(callback(data))
            .then(() => {
                setIsEditing(false)
            })
        // if(editing){
        //     dispatch(updateSubscription({ subscriptionId: subscription.id, args: data }))
        // }
    }

    // useEffect(() => {
    //     // handleSubmit(onSubmit)()
    // }, [watchFields])

    useEffect(() => {
        const discount = getValues('discount')
        const amount = getValues('amount')

        if (selectedVariant && selectedVariant.amount) {

            let planAmount = selectedVariant.amount
            let total = planAmount
            if (discountType === 'percentage') {
                let d = Math.min(discount, 100) / 100
                total = planAmount - (planAmount * d)
            } else if (discountType === 'overwrite') {
                if (amount) {
                    total = amount
                } else {
                    total = planAmount
                }
            }
            let formatted = formatMoneyWithCurrency(total, selectedVariant.currency_format)
            setCalculatedTotal(total)
            setCalculatedTotalFormatted(formatted)
        } else {
            setCalculatedTotal(0)
        }
    }, [selectedVariant, discountType, watchFields])

    // Need to make sure the form gets new values on rendering
    useEffect(() => {
        if (subscription) {
            reset({
                description: subscription?.description,
                reference: subscription?.reference,
                discount: subscription?.discount,
                amount: subscription?.amount,
                expires: subscription.active_until,
            })

            // If editing, find corresponding plan
            let plan = plans.find(plan => plan.id === parseInt(subscription.plan.parent_id))
            let variant = plan.variants.find(variant => variant.id === parseInt(subscription.plan.id))
            setSelectedPlan(plan)
            setSelectedVariant(variant)

            if (subscription.discount) {
                setDiscountType('percentage')
            } else if (subscription.amount) {
                setDiscountType('overwrite')
            }
        }
    }, [subscription])


    const selectPlanHandler = (plan) => {
        setSelectedPlan(plan)
        setSelectedVariant("")
        setIsEditing(true) . 
        focus()
    }

    const selectVariantHandler = (variant) => {
        setSelectedVariant(variant)
        setValue('plan', variant.id)
        setIsEditing(true)
    }

    const dateChangeHandler = (date) => {
        if (editing) {
            Promise.resolve(dispatch(setSubscriptionExpiry({ subscriptionId: subscription.id, args: { expires: date } })))
                .then(() => {
                    dispatch(setShouldUpdateList())
                })
        }
    }

    const focus = () => {
        selectRef.current?.focus();
    }

    return (
        <form className="subscription-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row align-items-end">
                <div className="col-md-6 col-12 mb-4">
                    <h2>{gettext("Plan")}</h2>
                    <Select
                        value={selectedPlan}
                        placeholder={gettext("Please select plan")}
                        onChange={selectPlanHandler}
                        options={plans}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                    />
                </div>
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext("Plan Variant")}</label>
                    <Select
                        ref={selectRef}
                        value={selectedVariant}
                        onChange={selectVariantHandler}
                        placeholder={gettext("Please select variant")}
                        options={selectedPlan?.variants ? selectedPlan.variants : []}
                        getOptionLabel={(option) => `${option.interval_count} ${gettext(option.interval)}, ${formatMoney(option.amount)} ${option.currency}`}
                        getOptionValue={(option) => option.id}
                        openMenuOnFocus
                    />
                </div>
            </div>
            {selectedPlan && selectedVariant &&
                <>
                    <div className="row align-items-end">
                        <div className="col-md-6 col-12 mb-4">
                            <label>{gettext("Valid until")}</label>
                            <FormDatepicker
                                fieldName={"expires"}
                                setValue={setValue}
                                register={register}
                                initial={subscription ? subscription.active_until : new Date()}
                                changeCallback={dateChangeHandler} />
                        </div>
                        <div className="col-md-6 col-12 mb-4">
                            <label>{gettext('Reference')}</label>
                            <input type="text" {...register("reference", { required: gettext('Field cannot be blank') })} className={`form-control ${errors.reference && "is-invalid"}`} />
                            {errors.reference && <div className="invalid-feedback">{errors.reference.message}</div>}
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-md-6 col-12 mb-4">
                            {/* TODO - Add below for selectable discount type, unused for now */}
                            {/* <label>
                            { discountOptions.map(option => (
                                <div key={option.value}>
                                    <input
                                        type="radio"
                                        value={option.value}
                                        name="discount"
                                        checked={selectedDiscountOption === option.value}
                                        onChange={() => setSelectedDiscountOption(option.value)}
                                        />
                                        { gettext(option.text) }
                                </div>
                            ))}
                        </label> */}
                            {/* { selectedDiscountOption === 'dropdown' && discounts && 
                            <select className="form-select" value={selectedDiscount} onChange={(e) => setSelectedDiscount(e.target.value)}>
                                {discounts.map((discount) => {
                                    return (
                                        <option value={discount.id}>{discount.name} {discount.discount}%</option>
                                    )
                                }
                                )}
                            </select>
                        }
                        { selectedDiscountOption === 'input' && 
                        <> */}
                            <label className="me-4">
                                <input
                                    type="radio"
                                    value={"disabled"}
                                    name="discount_type"
                                    defaultChecked={discountType === "disabled"}
                                    onChange={() => {
                                        setDiscountType("disabled")
                                        setValue('discount', null, { shouldTouched: true, shouldDirty: true })
                                        setValue('amount', null, { shouldTouched: true, shouldDirty: true })
                                    }}
                                    id={"disabled"}
                                    className="mb-2"
                                />
                                {gettext("No discount")}
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value={"percentage"}
                                    name="discount_type"
                                    defaultChecked={discountType === "percentage"}
                                    onChange={() => {
                                        Promise.resolve(setDiscountType("percentage"))
                                            .then(() => {
                                                setFocus('discount')
                                                setValue('amount', null, { shouldTouched: true, shouldDirty: true })
                                            })
                                    }}
                                    id={"percentage"}
                                />
                                {gettext("Discount %")}
                            </label>
                            <label className="me-2">
                                <input
                                    type="radio"
                                    value={"overwrite"}
                                    name="discount_type"
                                    defaultChecked={discountType === "overwrite"}
                                    onClick={() => {
                                        Promise.resolve(setDiscountType("overwrite"))
                                            .then(() => {
                                                setFocus('amount')
                                                setValue('discount', null, { shouldTouched: true, shouldDirty: true })
                                            })
                                    }}
                                    id={"overwrite"}
                                />
                                {gettext("Specify amount")}
                            </label>
                            <div class={`input-group ${discountType !== "disabled" && "d-none"}`}>
                                <input type='number' className="form-control readOnly" readOnly />
                                <span class="input-group-text">%</span>
                            </div>
                            {discountType === "percentage" &&
                                <>
                                    <div className={`input-group ${errors.discount && "is-invalid"}`}>
                                        <input
                                            type='number'
                                            {...register("discount", {
                                                required: gettext('Field cannot be blank'),
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: gettext('Please enter a number'),
                                                }
                                            })}
                                            className={`form-control ${errors.discount && "is-invalid"}`}
                                        />
                                        <span class="input-group-text">%</span>
                                        {errors.discount && <div className="invalid-feedback">{errors.discount.message}</div>}
                                    </div>
                                </>
                            }
                            {discountType === "overwrite" &&
                                <>
                                    <div className={`input-group ${errors.amount && "is-invalid"}`}>
                                        <input
                                            type='number'
                                            {...register("amount", {
                                                required: gettext('Field cannot be blank'),
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: gettext('Please enter a number'),
                                                }
                                            })}
                                            className={`form-control ${errors.amount && "is-invalid"}`}
                                        />
                                        <span class="input-group-text">{selectedVariant.currency_symbol}</span>
                                        {errors.amount && <div className="invalid-feedback">{errors.amount.message}</div>}
                                    </div>
                                </>
                            }
                        </div>
                        <div className="col-md-6 col-12 mb-4 d-flex flex-column justify-content-end">
                            <label>{gettext("Amount to charge")}</label>
                            <input type="text" className="form-control text-end readonly" value={calculatedTotalFormatted} readOnly />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-4">
                            <label>{gettext('Description')}</label>
                            <textarea {...register('description')} className="form-control" />
                        </div>

                    </div>

                    <div className="save-button-container">
                        <input className="btn btn-primary btn-sm mt-4 ms-auto" type="submit" value={gettext("Save")} />
                    </div>

                </>
            }

        </form>
    )
}

export default SubscriptionForm